import { Howl } from 'howler';
import React from 'react';

interface Props {
    src: string;
    isPlaying: boolean;
    onLoad: () => void;
    onPlay: () => void;
    onEnd: () => void;
}

interface State {
    howlId: number | null;
}

export class Howler extends React.Component<Props> {
    public state: State = {
        howlId: null,
    };

    private howl: Howl = new Howl({
        src: this.props.src,
        onload: this.props.onLoad,
        onplay: this.props.onPlay,
        onend: this.props.onEnd,
        html5: true,
    });

    public get duration(): number {
        return this.howl.duration();
    }

    public get seek(): number {
        return this.howl.seek() as number;
    }

    public set seek(seek: number) {
        this.howl.seek(seek);
    }

    private pause = () => {
        if (this.state.howlId) {
            return this.howl.pause(this.state.howlId);
        }

        return this.howl.pause();
    };

    private play = () => {
        if (this.howl.playing()) {
            return;
        }

        if (this.howl.state() === 'unloaded') {
            this.howl.load();
        }

        if (this.state.howlId) {
            return this.howl.play(this.state.howlId);
        }

        return this.setState({
            howlId: this.howl.play(),
        });
    };

    public togglePlay = () => (this.props.isPlaying ? this.pause() : this.play());

    public render(): JSX.Element {
        return <div />;
    }

    public componentWillUnmount(): void {
        this.howl.unload();
    }
}
